<div class="container">
    <nav class="navbar navbar-dark primary-color pull-right">
          <img src="./assets/images/logo/GOINGPLACES_RGB no tag.jpg" height="80" alt="mdb logo">
      </nav>
    <h2>{{completeSentence}}</h2>
    <div class="btnDiv">
        <button class="btn btn-primary" (click)="viewReport()">{{completeButtonText}}</button>
    </div>
</div>